import React, { Fragment, useEffect, useState } from "react";
import T from "prop-types";
import api from "APP_ROOT/api";
import { get, isEmpty } from "lodash";
import Warning from "../../shared/components/Warning/Warning";
import {
  INVENTORIES,
  REPAIR_AND_HOLD,
  SUGGESTED_RETAIL
} from "../../inventories/constants";
import { DataTable } from "../../shared/components/DataTables";
import { columnStyle } from "../../parts/components/ModifiedFlag";
import { RepairAndHold } from "../../inventories/components/Detail/Warnings";
import { alphaMonthYear } from "../../../lib/formatters/date";
import { LocationFlag } from "../../shared/components";
import { dollars } from "../../../lib/formatters/currency";
import useDebounce from "../../../hooks/useDebounce";

const SrpWarning = () => (
  <Warning>
    Warning: Your SRP does not match the next inventory item with matching
    conditions. Please try and keep pricing uniform.
  </Warning>
);

export const PreviousSrpConditionWarning = ({
  displayInventory,
  excludeInventoryId,
  srpCondition,
  srp,
  partId
}) => {
  const [inventories, setInventories] = useState([]);
  const debouncedSearchArgs = useDebounce(500, srpCondition, partId, srp);
  useEffect(() => {
    if (
      debouncedSearchArgs.filter(arg => ![undefined, null].includes(arg))
        .length > 2
    ) {
      api.inventories
        .search({
          exclude_inventory_id: excludeInventoryId,
          part_id: debouncedSearchArgs[1],
          matching_condition: debouncedSearchArgs[0],
          ranking: true,
          limit: 3
        })
        .then(res => {
          setInventories(res.data.results);
        });
    }

    return function cleanup() {};
  }, debouncedSearchArgs);

  if (
    inventories.length > 0 &&
    !isEmpty(srp) &&
    parseFloat(srp) !== parseFloat(get(inventories, `[0].${SUGGESTED_RETAIL}`))
  ) {
    if (displayInventory) {
      return (
        <Fragment>
          <SrpWarning />
          <h2>Next In Line</h2>
          <DataTable.Mini noMargin>
            <DataTable.Head>
              <th />
              <th>Serial Number</th>
              <th>CD</th>
              <th>Tag Date</th>
              <th className="text-center">Store Location</th>
              <th className="text-right">Cost/Unit</th>
              <th className="text-right">Exch SRP</th>
              <th className="text-right">SRP</th>
            </DataTable.Head>
            <DataTable.Body>
              {inventories.map(inventory => (
                <tr>
                  <td />
                  <td>{inventory.serial_number}</td>
                  <td style={columnStyle.conditionColumn}>
                    {get(
                      INVENTORIES,
                      `condition.${inventory.condition}.abbrev`
                    )}
                  </td>
                  <td>
                    <RepairAndHold inventory={inventory} />
                    {inventory.status !== REPAIR_AND_HOLD &&
                      alphaMonthYear(inventory.tag_date)}
                  </td>
                  <td className="text-center">
                    <LocationFlag location={inventory.store_location_id} />
                  </td>
                  <td className="text-right">
                    {inventory.cost_per_unit &&
                      dollars(inventory.cost_per_unit)}
                  </td>
                  <td className="text-right">
                    {inventory.exchange_srp && dollars(inventory.exchange_srp)}
                  </td>
                  <td className="text-right">
                    {inventory.suggested_retail &&
                      dollars(inventory.suggested_retail)}
                  </td>
                </tr>
              ))}
            </DataTable.Body>
          </DataTable.Mini>
        </Fragment>
      );
    }
    return <SrpWarning />;
  }
  if (inventories.length !== 0) setInventories([]);

  return null;
};

PreviousSrpConditionWarning.propTypes = {
  displayInventory: T.bool,
  excludeInventoryId: T.number,
  partId: T.number,
  srpCondition: T.string,
  srp: T.string
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/shared/PreviousSrpConditionWarning.jsx